module.exports = __webpack_public_path__ + "img/about-office-img-3.8571c9bc.jpg";